// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","secondary":"#33C370","textDefault":"#808080","container":"_7QbvDuyQqu6sJwrQa7xFp","row":"_2QfF9UXp18PhvbHSHUJb21","head-row":"_3Hm1CmN0OowK-POD76TX9O","cell":"hHDtQtWMyQVj-RjFPoUI5","cell-title":"_3mU8rQ1fiHiwRpiM_6h9Ny","column":"_2yRnENGd9xiMBzMsm077Oy","mob-row":"_1flS8h_Sc2PueByIET4cTs","cell-header":"_3H6jN1FjgndZSao8eyZqpN","textArea":"lmCDeTAJXObPXuD1Ay-E0","input":"ySo-gOwgfAz6TobzX0qG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/InputTable.mod.css
// module id = 1706
// module chunks = 0